module.exports = __webpack_public_path__ + "static/media/ny-che-small-mobile@2x.f9077a07.png";